"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesSpiClient = void 0;
require("@redbox-ruby/data-lib");
function servicesSpiClient(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
networkClient) {
    return {};
}
exports.servicesSpiClient = servicesSpiClient;
